// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CustomButton_wrapper__23Hur","button":"CustomButton_button__3PYLn"};